module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.list), function(item, index) {
    return (index < 6) ? _c('li', {
      key: item.goods_id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goods_id
          }
        },
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": item.thumbnail
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title",
      attrs: {
        "title": item.NAME
      }
    }, [_vm._v(_vm._s(item.NAME))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "symbol"
    }, [_vm._v("¥")]), _vm._v(_vm._s(item.price) + " "), _c('span', {
      staticClass: "jsNum"
    }, [_vm._v("¥" + _vm._s(item.mktprice))])]), _vm._v(" "), _c('div', {
      staticClass: "store"
    }, [_vm._v("库存：" + _vm._s(item.store) + "件")]), _vm._v(" "), _c('div', {
      staticClass: "button"
    }, [_vm._v("抢购")])])], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-639d657a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/buy-limit/list.vue
// module id = 1618
// module chunks = 1